import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../controls/Material-Table-Components';
import { v4 as uuidv4 } from 'uuid';

import SystemContext from "../../../SystemContext";

import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import {useFlightLoadContent, useAddFlightLoadContent, useDeleteFlightLoadContent, useUpdateFlightLoadContent} from "../../../services/flights";
import { useTheme } from '@material-ui/core';


const DeadloadEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('DeadLoad.AddFunction', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const props = {
    ..._props
  }
  const {classes, extraKeys} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const handleAddDeadLoad = useAddFlightLoadContent();
  const handleUpdateDeadLoad = useUpdateFlightLoadContent();
  const handleDeleteDeadLoad = useDeleteFlightLoadContent();

  const queryClient = useQueryClient();
  const deadLoad = useFlightLoadContent({queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    //const validatorColumn = ValidatorColumn(DeadloadEditorValidator, false);

    return [
      //{...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(80,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Deck",
        field: "deck",
        //defaultGroupOrder: 0
      },
      {
        ...baseColumn,
        ...ColumnWidth(50,2,undefined,undefined,undefined,undefined,false),
        title: "Nr",
        field: "sequence",
      },
      {
        ...baseColumn,
        ...ColumnWidth(60,2,undefined,undefined,undefined,undefined,false),
        title: "Contour",
        field: "contour",
        editable: "never",
      },
      {
        ...baseColumn,
        ...ColumnWidth(50,2,undefined,undefined,undefined,undefined,false),
        title: "Height",
        field: "height",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,undefined,undefined,false),
        title: "ULD",
        field: "uld",
      },
      {
        ...baseColumn,
        ...ColumnWidth(50,2,undefined,undefined,undefined,undefined,false),
        title: "Gross Weight",
        field: "grossWeight",
      },
      {
        ...baseColumn,
        ...ColumnWidth(60,2,undefined,undefined,undefined,undefined,false),
        title: "Loading Point",
        field: "airportOfLoading",
      },
      {
        ...baseColumn,
        ...ColumnWidth(60,2,undefined,undefined,undefined,undefined,false),
        title: "Offload Point",
        field: "airportOfUnloading",
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,undefined,undefined,false),
        title: "Final Destination",
        field: "finalDestinationAirport",
      },
      {
        ...baseColumn,
        //...ColumnWidth(50,2,undefined,undefined,undefined,undefined,false),
        title: "Special Handling",
        field: "shcs",
      },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor} style={{width: "100%", overflow: "scroll", maxHeight: 700}}>
          <MaterialTable
            tableRef={tableRef}
            data={deadLoad.data}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              grouping: false
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={600}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Dead Load Statement"
            columns={getColumns({...props, canEdit: state.canEdit})}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: state.canEdit
                ? (newData) => new Promise((resolve, reject) => {
                    handleAddDeadLoad.mutate({record: newData, resolve, reject, extraKeys});
                  })
                : undefined,
              onRowUpdate: state.canEdit
                ?
                  (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    handleUpdateDeadLoad.mutate({record: newData, oldRecord: oldData, resolve, reject, extraKeys});
                  })
                : undefined,
              onRowDelete: state.canEdit
                ? (oldData) =>
                  new Promise((resolve, reject) => {
                    handleDeleteDeadLoad.mutate({oldRecord: oldData, resolve, reject, extraKeys});
                  })
                : undefined,
            }}
        />
      </div>
  );
}

export default DeadloadEditor;
